import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button} from 'Components';
import i18n from 'i18next';
import './ConfirmAccessModal.css';

const ConfirmAccessModal = ({
  messageLine1,
  messageLine2,
  onProceedClick,
  link,
  url,
  proceedDisabled = false
}) => (
  <Modal show>
    <div className="confirm-modal">
      <div className="confirm-modal__container">
        <p>{messageLine1}</p>
        <p>{messageLine2}</p>
        <div className="confim-modal__link">
          <a href={url} target="_blank">{link}</a>
        </div>
        <Button onClick={onProceedClick} className="button--primary" disabled={proceedDisabled}>
          {i18n.t('common:Proceed')}
        </Button>
       
      </div>
    </div>
  </Modal>
);

ConfirmAccessModal.propTypes = {
  messageLine1: PropTypes.string,
  messageLine2: PropTypes.string,
  onProceedClick: PropTypes.func,
  proceedDisabled: PropTypes.bool,
};

export default ConfirmAccessModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmAccessModal/ConfirmAccessModal.jsx